import endpoints from 'api/endpoints';

export default ({ version, lang, id }) => ({
  url: endpoints.deleteTermsUrl(version, lang, id),
  queryKey: `delete${endpoints.deleteTermsUrl()}`,
  meta: {
    authToken: true,
  },
  force: true,
  options: {
    headers: {
      Accept: 'application/json',
    },
    method: 'DELETE',
  },
  update: {
    term: (prevEntities) => prevEntities.filter((item) => item.get('id') !== id),
  },
  updateResult: {
    terms: (prevResult) => {
      console.log('prevResult');
      console.log(prevResult);
      console.log(id);
      console.log(prevResult.filter((item) => item.get('id') !== id));
      return prevResult.filter((item) => item.get('id') !== id);
    },
  },
});
